// John Eldhose 20200611

const emailValid = (email) => {
  return /\S+@\S+\.\S+/.test(email);
}
const matchObjs = (obj1, obj2, obj) => {
  var mat = (typeof obj1[obj] === typeof obj2[obj]);
  if(mat === false || typeof obj1[obj] === 'undefined')
    return mat;
  var arr1 = Object.keys(obj1[obj]); var arr2 = Object.keys(obj2[obj]);
  if(arr1.length !== arr2.length)
    return false;
  const match = (arr) => {
    for(var i = 0; i < arr.length; i++)
      if(obj1[obj][arr[i]] !== obj2[obj][arr[i]])
        return false;
    return true;
  }
  return ((arr2.length > arr1.length) ? match(arr2) : match(arr1));
}
const stream = (f, dl = false) => {
  return ('/api/stream.php?f=' + f + (dl ? '&dl=1' : ''));
}

export { emailValid, matchObjs, stream };



// WEBPACK FOOTER //
// ./src/components/lib/lib.js